import axios from 'axios'
import { encryptMD5, BrowserInfo } from '@/utils'
import { Base64 } from 'js-base64'
import store from '@/store'
import { IOS, Android } from '../JsBrage'
// 创建 axios 接口
let service = axios.create({
  baseURL: process.env.VUE_APP_JAVA_API,
  // baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000,
  responseType: 'json',
  headers: { 'Content-Type': 'application/json' }
})

// request拦截器
service.interceptors.request.use(
  config => {
    // let key = process.env.VUE_APP_SERVER_KEY
    // let signType = process.env.VUE_APP_SIGN_TYPE
    // let timestamp = Math.round(new Date().getTime() / 1000).toString()
    // let sign = encryptMD5(key + '&' + signType + '&' + timestamp)

    // const data = {
    //   channel: 3,
    //   sign: sign,
    //   timestamp: timestamp
    // }

    // Header 参数
    let version = '1.0',
      clientId = '050884761363161',
      timestamp = Math.round(new Date().getTime()).toString()
    let params =
      'keyclientId' +
      clientId +
      'timestamp' +
      timestamp +
      'version' +
      version +
      'secret'
    let sign = Base64.encode(encryptMD5(params)).toUpperCase()
    config.headers = {
      ...config.headers,
      sign: sign,
      version: version,
      clientId: clientId,
      timestamp: timestamp,
      token: ''
    }

    // if (config.method === 'post') {
    //   config.params = data
    //   config.data = JSON.stringify(config.data)
    // } else {
    //   config.params = {
    //     ...config.params,
    //     ...data
    //   }
    // }
    return config
  },
  error => {
    Promise.reject(error)
  }
)
// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    let msg = ''
    if (res.msg == 'success') {
      if (res.code != '200') {
        // 校验错误
        return Promise.resolve(res.code)
      } else {
        return Promise.resolve(res.data)
      }
    } else {
      switch (res.code) {
        case '209': // 重新登录
          if (store.getters.platformChannel === '10') {
            var pl = BrowserInfo()
            if (pl.isIOS) {
              IOS.IosTransferLogin()
            } else {
              Android.AndroidTransferLogin()
            }
          } else {
            location.href =
              process.env.VUE_APP_ROOT_URL +
              'index.html#/login?return_url=' +
              window.location.href
          }
          msg = '请登录'
          break
        case '500': // 系统异常
          msg = '系统异常，请稍后重试'
          break
        default:
          msg = res.msg
      }
    }
    return Promise.reject(msg)
  },
  error => {
    return Promise.reject(error)
  }
)

/**
 * @description: post请求
 * @param {type}
 * @return: promise
 */
export function java_post(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.post(url, data).then(
      response => {
        resolve(response)
      },
      err => {
        reject(err)
      }
    )
  })
}
/**
 * @description: get请求
 * @param {type}
 * @return: promis
 */
export function java_get(url, params = {}) {
  return new Promise((resolve, reject) => {
    service
      .get(url, {
        params: params
      })
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        // Toast(err)
        reject(err)
      })
  })
}
